
<div>
<div class="progress-container">
    <div class="progress-bar" [style.width.%]="dealAge"></div>
  </div>
  
  <span>{{ dealAge }}% Completed</span>
</div>